import React, {Component} from 'react';
import {Col} from 'react-flexbox-grid';
import Mansory from 'react-masonry-component';
import _ from "underscore";
import moment from "moment";
import Format from "./Format";
import {Link} from 'react-router-dom';

class Line extends Component {


    render() {
        let key = "Activité";

        if (!(key in this.props.entry.fields)) {
            return null;
        }

        const entry = this.props.entry.fields[key][0];

        let title = this.props.entry.fields['Activité'][0].fields['Titre: Nom de l\'intervention'];

        const dateStart = moment(this.props.entry.fields['Date et heure début']);
        const dateEnd = moment(this.props.entry.fields['Date et heure fin']);
        let date = null;
        let format = null;
        if (this.props.configuration.filter == "entreprise") {
            date = dateStart.format('DD/MM HH:mm');
            format = (<td className="List-Format">
                <Format entry={this.props.entry}/>
            </td>)
        } else {
            if (this.props.configuration.group == "Thème#Thématique" || this.props.configuration.group == 'Alentour') {
                date = dateStart.format('DD/MM HH:mm');
                format = (<td className="List-Format">
                    <Format entry={this.props.entry}/>
                </td>)
            } else if (this.props.configuration.group == "Format") {
                date = dateStart.format('DD/MM HH:mm');
            } else {
                date = dateStart.format('HH:mm');
                format = (<td className="List-Format">
                    <Format entry={this.props.entry}/>
                </td>)
            }
        }

        let places = [];
        _.each(this.props.entry.fields['Lieu'], (place) => {
            places.push(place.fields.Name);
        })


        return (

            <tr>
                <td className="List-Date">
                    <Link to={"/record/" + this.props.entry.id}>
                        <i className="far fa-clock"/>
                        {date}
                    </Link>
                </td>
                {format}
                <td className="List-Places">
                    <i className="fas fa-map-marker-alt"/>
                    {places.join(', ')}
                </td>
                <td className="List-Title">
                    <Link to={"/record/" + this.props.entry.id}>
                        {title}
                    </Link>
                </td>
            </tr>
        );
    }
}

export default Line;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCardsV2/Line.js